import type { ReactNode } from 'react'

import { cn } from '../../utils/cn'

type FilterFieldProps = {
  label: string
  className?: string
  children: ReactNode
}

/** Caption above a filter control, as laid out in the design. */
export const FilterField = ({ label, className, children }: FilterFieldProps) => (
  <div className={cn('flex flex-col items-start gap-[6px]', className)}>
    <span className="font-host text-[14px] font-normal leading-normal text-dash-field-label">
      {label}
    </span>
    {children}
  </div>
)
